<template>
    <div>
        <label v-show="hasLabel" :for="id" class="block text-sm font-medium text-gray-700">{{ label }}<span v-show="$attrs.required || false" class="text-teal font-bold">*</span></label>
        <div class="flex" :class="{
            'mt-1': hasLabel,
            'rounded-md': hasPrefix
        }">
            <span v-show="hasPrefix" class="flex-grow-0 inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 sm:text-sm">
                <slot name="prefix"></slot>
            </span>
            <input :type="$attrs.type || 'text'" :id="id" :value="modelValue" v-bind="$attrs" class="flex-1 focus:ring-teal focus:border-teal block w-full sm:text-sm border-gray-200" :class="{
                'rounded-r-md': hasPrefix,
                'rounded-md': !hasPrefix,
                'bg-gray-100' : $attrs.disabled
            }" @input="handleInput($event)">
        </div>
        <div v-show="$attrs.maxlength" class="mt-2 text-sm text-gray-500 text-right">
            <span>{{ counter }}</span>/{{ $attrs.maxlength }}
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        label: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default(){
                return 'input-field-' + Math.random().toString(36).substr(2, 9);
            }
        },
        modelValue: null
    },
    emits: ['update:modelValue'],
    setup(_, { emit }){
        function handleInput(e){
            emit('update:modelValue', e.target.value);
        }

        return {
            handleInput
        }
    },
    computed: {
        hasLabel(){
            return this.label != ''
        },
        hasPrefix(){
            return this.$slots.prefix
        },
        counter(){
            return (this.modelValue) ? this.modelValue.length : 0
        }
    }
}
</script>

<style>

</style>
